/**
 * SingletonGateScreen v2 — shown when the user tries to browse Discover while a retreat
 * is actively running. Navigation always goes forward to live, never back.
 *
 * UI-INV-005: Leaf component, props only, no engine imports.
 */
import styles from "./SingletonGateScreen.module.css";
import { IntentStrip } from "../components/IntentStrip";
import { TEST_IDS } from "../testing/testIds";

type Props = {
  retreatName: string;
  intentLabels: string[];
  whisperLine?: string;
  onReturn: () => void;
  onEnd: () => void;
};

export function SingletonGateScreen({ retreatName, intentLabels, whisperLine, onReturn, onEnd }: Props) {
  return (
    <div className={styles.gate} data-testid="singleton-gate-screen">
      {/* MetaStrip */}
      <div className={styles.meta}>
        <button className={styles.backLink} onClick={onReturn} type="button">
          ← keep practising
        </button>
      </div>

      {/* IntentStrip */}
      {intentLabels.length > 0 && (
        <div className={styles.stripWrap}>
          <IntentStrip intents={intentLabels} data-testid={TEST_IDS.INTENT_STRIP} />
        </div>
      )}

      <div className={styles.content}>
        {/* Hairline above heading */}
        <div className={styles.hairline} data-testid="singleton-gate-hairline" />

        <p className={styles.retreat}>{retreatName}</p>
        <h1 className={styles.heading}>You are already on retreat.</h1>
        {whisperLine && <p className={styles.whisper}>{whisperLine}</p>}
      </div>

      <div className={styles.actions}>
        <button className={styles.primary} onClick={onReturn} type="button" data-testid="singleton-return-btn">
          Return to practice
        </button>
        <button className={styles.ghost} onClick={onEnd} type="button" data-testid="singleton-end-btn">
          End the retreat first
        </button>
      </div>
    </div>
  );
}
